import { render, staticRenderFns } from "./LevelsTab.vue?vue&type=template&id=2fdc369b&scoped=true"
import script from "./LevelsTab.vue?vue&type=script&lang=js"
export * from "./LevelsTab.vue?vue&type=script&lang=js"
import style0 from "./LevelsTab.vue?vue&type=style&index=0&id=2fdc369b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc369b",
  null
  
)

export default component.exports